import type { Task, Sprint } from '@/lib/types'
import type { Filters, DevDerived } from './types'
import { riskFlags, taskInSprint, type RiskCtx } from '@/lib/dev-sprint'

const norm = (x?: string | null) => (x ?? '').trim().toLowerCase()

/** Apakah task lolos filter aktif. */
export function taskMatchesFilters(t: Task, filters: Filters, derived: DevDerived, riskCtx: RiskCtx): boolean {
  if (filters.dev && norm(t.assignee) !== filters.dev) return false
  if (filters.project && t.projectId !== filters.project) return false
  if (filters.status && derived.statusOf(t) !== filters.status) return false
  if (filters.priority && t.priority !== filters.priority) return false
  if (filters.risk && riskFlags(t, riskCtx).length === 0) return false
  return true
}

/** Task ada di salah satu sprint (untuk membedakan backlog vs milik sprint lain). */
export function inAnySprint(t: Task, sprints: Sprint[]): boolean {
  return sprints.some((s) => taskInSprint(t, s))
}
